import React__default from 'react';
import { S as StyledSvg, V as Variant } from './StyledSvg-Bc-aUfmk.js';

const VeryDissatisfied = ({
  disabled,
  checked
}) => /*#__PURE__*/React__default.createElement(StyledSvg, {
  $checked: checked,
  $disabled: disabled,
  $variant: Variant.VERY_DISSATISFIED,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "15",
  cy: "15",
  r: "15"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M7.18333 20.4228C6.86459 20.8739 6.97182 21.4979 7.42284 21.8166C7.87386 22.1354 8.49788 22.0281 8.81663 21.5771C10.3 19.4782 12.5967 18 15 18C17.4033 18 19.7 19.4782 21.1833 21.5771C21.5021 22.0281 22.1261 22.1354 22.5771 21.8166C23.0281 21.4979 23.1354 20.8738 22.8166 20.4228C21.0692 17.9503 18.2235 16 15 16C11.7765 16 8.9307 17.9503 7.18333 20.4228Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 11C12 12.1046 11.1046 13 10 13C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9C11.1046 9 12 9.89543 12 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22 11C22 12.1046 21.1046 13 20 13C18.8954 13 18 12.1046 18 11C18 9.89543 18.8954 9 20 9C21.1046 9 22 9.89543 22 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM2 15C2 7.8203 7.8203 2 15 2C22.1797 2 28 7.8203 28 15C28 22.1797 22.1797 28 15 28C7.8203 28 2 22.1797 2 15Z"
}));

export { VeryDissatisfied as V };
//# sourceMappingURL=VeryDissatisfied-C-P0DUhe.js.map
